import React from 'react'
import "./Headerbar.css"
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router-dom'; 

const useStyles = makeStyles(theme => ({
    topbar: {
        backgroundColor: 'transparent'
    },
    title: {
        flexGrow: 1,
    },
    btn: {
        color: 'white',
        backgroundColor: '#00bb7d',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#0C2D48'
        },
        cursor: 'pointer',
        fontSize: '12px',
        height: '36px'
    }
}))


const Headerbar = ({ setOpenMenu }) => {
    const navigate = useNavigate();
    const classes = useStyles();


    return (
        <div>
            
        </div>
        
    )
}

export default Headerbar
